import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/overview';
const req = require.context('!raw-loader!../../../markdowns/overview', false, /\.(md|jsx)$/);

export default function Overview() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
